<script>
    import { t } from "../../../../i18n";
    import DeadlineBadge from "../../DeadlineBadge.svelte";

    export let data = {};

    let rows = data.hotels||[];
    let rand = (min,max) => Math.floor(Math.random() * max) + min;
    let buildBadge = function(row, tr){
        let status = (row||{}).status||{};
        switch(status.id){
            case 2:     return `<div class="badge badge-info mr-1 mb-1">${status.txt||tr('badge.waiting_list')}</div>`;
            case 3:     return `<div class="badge badge-danger mr-1 mb-1">${status.txt||tr('badge.no_availability')}</div>`;
            case 4:     return `<div class="badge badge-success mr-1 mb-1">${status.txt||tr('badge.confirmed')}</div>`;
            case 6:     return `<div class="badge badge-danger mr-1 mb-1">${status.txt||tr('badge.canceled')}</div>`;
            default:    return `<div class="badge badge-warning mr-1 mb-1">${tr('badge.on_request')}</div>`;
        }
    };
    let canRender = function(row){
        if(!row.hotelName)return false;
        if(row.hotelCity.match(/\sAirport$/))return false;
        return true;
    };
</script>

<!--
{JSON.stringify(data.hotels)}
-->

{#if rows.length}


<div class="table-responsive">
    <table class="table mb-0">
        <thead class="thead-dark">
        <tr>
            <th>{$t('hotels.day')}</th>
            <th>{$t('hotels.hotel')}</th>
            <th>{$t('hotels.city')}</th>
            <th>{$t('hotels.status')}</th>
            <th>{$t('deadlines.deadline')}</th>
        </tr>
        </thead>
        <tbody>

        {#each rows as row}
        {#if canRender(row)}
            <tr>
                <td>{$t('common.day_n', {n: row.day})}</td>
                <td>{row.name}</td>
                <td>{row.hotelCity}</td>
                <td>{@html buildBadge(row, $t)}</td>
                <td><DeadlineBadge deadline={row.deadline}></DeadlineBadge></td>
            </tr>
        {/if}
        {/each}

        </tbody>
    </table>


</div>

{:else}
    {$t('common.no_data')}
{/if}